<p-avatar shape="circle" [size]="size"
[label]="_tipo" [style]="_tipoStyle" [icon]="icon"></p-avatar>
